export default __webpack_public_path__ + "static/media/doc.fe70d3b5.svg";